module.exports = __webpack_public_path__ + "e4054edab7a3d692f80340f294955a5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./demo/img/bookarticle.jpg
// module id = 300
// module chunks = 0